import { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { Route } from 'react-router-dom';
import { KoobPageHeader, KoobSettingsBody, KoobSettingsModal } from '@koob/ui';
import { useApp } from 'hooks';
import { decodeId } from 'utils';
import { settingsSections } from 'components/settingsAreas';
import ExperienceSettingsRoutes from 'containers/ExperiencesSettings/routes';

const HotelsSettings = lazy(() => import('containers/HotelsSettings'));
const TravelersSettings = lazy(() => import('containers/TravelersSettings'));
const TravelDiarySettings = lazy(
  () => import('containers/TravelDiarySettings'),
);
const Locations = lazy(() => import('containers/Locations'));
const Settings = lazy(() => import('containers/Settings'));
const NotificationPreferences = lazy(
  () => import('containers/Profile/NotificationPreferences'),
);

function Notifications() {
  const { t } = useTranslation('mainSidebar');
  const { user } = useApp();

  return (
    <>
      <KoobPageHeader title={t('settingsModal.notifications')} />
      <KoobSettingsBody>
        <NotificationPreferences userId={decodeId(user.id)} />
      </KoobSettingsBody>
    </>
  );
}

/**
 * DMC's settings modal: its pages keep their URLs (/settings/*, /locations/*,
 * /user/notification-preferences); App.js renders them here, over the last
 * page, and onClose goes back to it.
 */
export default function SettingsModal({ open, onClose }) {
  const { t } = useTranslation('mainSidebar');
  const { user, isAllowedTo } = useApp();

  return (
    <KoobSettingsModal
      open={open}
      groups={settingsSections(t, isAllowedTo)}
      user={{
        name: user?.firstName
          ? `${user.firstName} ${user.lastName || ''}`
          : user?.email,
        email: user?.email,
      }}
      onClose={onClose}
    >
      <Route path="settings/hotels/*" element={<HotelsSettings />} />
      <Route
        path="settings/experiences/*"
        element={<ExperienceSettingsRoutes />}
      />
      <Route path="settings/travelers/*" element={<TravelersSettings />} />
      <Route path="settings/travel-diary/*" element={<TravelDiarySettings />} />
      <Route path="settings/*" element={<Settings />} />
      <Route path="locations/*" element={<Locations />} />
      <Route path="user/notification-preferences" element={<Notifications />} />
    </KoobSettingsModal>
  );
}
